import {
  withStyles,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  CheckboxProps,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles';

import React, {
  ReactNode,
  useState,
  useEffect,
  useRef,
  MutableRefObject,
} from 'react';

// onchange example----------------------------------------------------
// export const RadioInputChange = UpdateData => (e, value: string) => {
//     UpdateData({ [e.target.name]: value });
// }

// const----------------------------------------------------
export const EmptyCheckboxMsg = '如果你要繼續執行，請勾選這個核取方塊。';

// style----------------------------------------------------
const useCkeckboxStyle = makeStyles<Theme, ICheckbox>(() => ({
  root: (props) => (props.ckeckboxStyle ? props.ckeckboxStyle : {}),
}));

const useLabelStyle = makeStyles<Theme, ICheckbox>(() => ({
  label: (props) => (props.labelStyle ? props.labelStyle : {}),
}));

export const StyleFormControl = withStyles(() => ({
  root: {
    // padding: '5px',
  },
}))(FormControl);

export const StyleFormHelperText = withStyles(() => ({
  root: {
    margin: '0',
  },
}))(FormHelperText);

interface ICheckbox
  extends Omit<CheckboxProps, 'inputRef' | 'value' | 'onClick'> {
  label?: ReactNode;
  labelStyle?: CreateCSSProperties;
  ckeckboxStyle?: CreateCSSProperties;
  inputRef?: MutableRefObject<HTMLInputElement | undefined>;

  verifyBeforeChange?: boolean;
  error?: boolean;
  helperText?: ReactNode;
}

// component----------------------------------------------------
const CheckBox = (props: ICheckbox): JSX.Element => {
  const {
    checked,
    inputRef = useRef(),
    verifyBeforeChange = false,
    error,
    helperText,
    label,
    labelStyle,
    ckeckboxStyle,
    ...other
  } = props;
  const checkboxClasses = useCkeckboxStyle(props);
  const labelClasses = useLabelStyle(props);

  const [message, setMessage] = useState('');
  const [FirstVerify, setFirstVerify] = useState(verifyBeforeChange);

  useEffect(() => {
    // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
    if (!FirstVerify) {
      setFirstVerify(true);
      setMessage('');
      return;
    }

    // 驗 HTML validation
    if (inputRef.current) {
      const { validationMessage } = inputRef.current;
      if (validationMessage.length > 0) {
        setMessage(validationMessage);
        return;
      }
    }

    // 先前檢驗都 pass
    setMessage('');
  }, [checked, verifyBeforeChange]);

  return (
    <StyleFormControl error={error || message.length > 0}>
      <FormControlLabel
        classes={labelClasses}
        inputRef={inputRef}
        control={
          <Checkbox checked={checked} classes={checkboxClasses} {...other} />
        }
        label={label}
        style={!label ? { margin: 0 } : {}}
      />
      <StyleFormHelperText>{helperText || message}</StyleFormHelperText>
    </StyleFormControl>
  );
};

export default CheckBox;
